import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RiseOutlined } from '@ant-design/icons';
import { useAddAdditionalCost } from 'api/additional-cost/use-add-additional-cost';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { AdditionalCostModal } from 'components/common/additional-cost-modal';
import type { IAdditionalCostFormFields } from 'components/common/additional-cost-modal/types';
import type { IOrderAddAdditionalCostProps } from './types';

const OrderAddAdditionalCostComponent: React.FC<IOrderAddAdditionalCostProps> = (props) => {
  const { orderId } = props;
  const { t } = useTranslation('additional-cost');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { mutateAsync: addAdditionalCost, isLoading } = useAddAdditionalCost();

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const onFinish = async (values: IAdditionalCostFormFields) => {
    await addAdditionalCost({ ...values, orderId });
  };

  return (
    <>
      <Button icon={<RiseOutlined />} onClick={handleOpen}>
        {t('add_additional_cost')}
      </Button>
      <AdditionalCostModal isLoading={isLoading} isOpen={isModalOpen} onClose={handleClose} onFinish={onFinish} />
    </>
  );
};

export const OrderAddAdditionalCost = withRoleGuard<IOrderAddAdditionalCostProps>(OrderAddAdditionalCostComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
  UserRole.customer_manager,
  UserRole.storekeeper,
]);
